var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});

function default_1(number, index) {
  return [["agora mesmo", "agora"], ["h\xE1 %s segundos", "em %s segundos"], ["h\xE1 um minuto", "em um minuto"], ["h\xE1 %s minutos", "em %s minutos"], ["h\xE1 uma hora", "em uma hora"], ["h\xE1 %s horas", "em %s horas"], ["h\xE1 um dia", "em um dia"], ["h\xE1 %s dias", "em %s dias"], ["h\xE1 uma semana", "em uma semana"], ["h\xE1 %s semanas", "em %s semanas"], ["h\xE1 um m\xEAs", "em um m\xEAs"], ["h\xE1 %s meses", "em %s meses"], ["h\xE1 um ano", "em um ano"], ["h\xE1 %s anos", "em %s anos"]][index];
}

exports.default = default_1; //# sourceMappingURL=pt_BR.js.map

export default exports;
export const __esModule = exports.__esModule;